module.exports = __webpack_public_path__ + "static/media/pwa2.6626b0db.png";